import React, { useEffect } from "react";
import PDFIcon from "../images/PDF_file_icon.png";
import {
  deleteLectureOverviewPermanently,
  deleteProgramWeekLectureOverviewPermanently,
  deleteWeekDayOverviewPermanently,
  deleteWeekOverviewPermanently,
  deleteWorkoutOverviewPermanently,
  remove_session,
  updateLectureOverview,
  updateProgramWeekLectureOverview,
  updateWeekDayOverview,
  updateWeekOverview,
  updateWorkoutOverview,
} from "../functions/general";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import ArrowDown from "../images/ArrowDown.svg";
import Media from "./Media";
import { usePermissions } from "../functions/usePermissions";
import DragHandler from "./DragHandler";

const PDFOverview = ({ item, fetchData, getLoggedInUser, type, index }) => {
  const { hasPermission } = usePermissions();
  const navigate = useNavigate();
  const [isOpen, setIsopen] = React.useState(index === 0 ? true : false);
  const [loading, setLoading] = React.useState(false);
  const [pdfLoading, setPdfLoading] = React.useState(true);
  const [pdf, setPdf] = React.useState(item?.url ?? "");
  const [fileName, setFileName] = React.useState(item?.title);
  const [fileSize, setFileSize] = React.useState(item?.fileSize);

  const [title, setTitle] = React.useState(item?.title);

  const [showUpdatePDFModal, setShowUpdatePDFModal] = React.useState(false);

  useEffect(() => {
    setPdfLoading(true);
    const loader = setTimeout(() => {
      setPdfLoading(false);
    }, 400);
    return () => {
      clearTimeout(loader);
    };
  }, [isOpen]);

  const handleUpdateOverviewPDF = (e) => {
    e.preventDefault();
    if (loading) return false;
    if (pdf) {
      setLoading(true);
      if (type === "week") {
        const PDFData = {
          title: title ?? "",
          fileSize: fileSize ?? "",
          url: pdf,
          text: "",
          type: "pdf",
          week: item?.week,
        };
        updateWeekOverview(PDFData, item?._id).then((res) => {
          if (res && res.status == 200) {
            fetchData();
            toast.success("PDF updated successfully.");
            document.getElementById("categoryModalCloseButton").click();
          } else if (res && res.status == 401) {
            remove_session();
            getLoggedInUser();
            navigate("/login");
          } else {
            toast.error("Failed to update PDF.");
          }
          setLoading(false);
        });
      } else if (type === "day") {
        const PDFData = {
          title: title ?? "",
          fileSize: fileSize ?? "",
          url: pdf,
          text: "",
          type: "pdf",
          weekDay: item?.weekDay,
        };
        updateWeekDayOverview(PDFData, item?._id).then((res) => {
          if (res && res.status == 200) {
            fetchData();
            toast.success("PDF updated successfully.");
            document.getElementById("categoryModalCloseButton").click();
          } else if (res && res.status == 401) {
            remove_session();
            getLoggedInUser();
            navigate("/login");
          } else {
            toast.error("Failed to update PDF.");
          }
          setLoading(false);
        });
      } else if (type === "lecture") {
        const PDFData = {
          title: title ?? "",
          fileSize: fileSize ?? "",
          url: pdf,
          text: "",
          type: "pdf",
          lecture: item?.lecture,
        };
        updateLectureOverview(PDFData, item?._id).then((res) => {
          if (res && res.status == 200) {
            fetchData();
            toast.success("PDF updated successfully.");
            document.getElementById("categoryModalCloseButton").click();
          } else if (res && res.status == 401) {
            remove_session();
            getLoggedInUser();
            navigate("/login");
          } else {
            toast.error("Failed to update PDF.");
          }
          setLoading(false);
        });
      } else if (type === "programWeekLecture") {
        const PDFData = {
          title: title ?? "",
          fileSize: fileSize ?? "",
          url: pdf,
          text: "",
          type: "pdf",
          lecture: item?.lecture,
        };
        updateProgramWeekLectureOverview(PDFData, item?._id).then((res) => {
          if (res && res.status == 200) {
            fetchData();
            toast.success("PDF updated successfully.");
            document.getElementById("categoryModalCloseButton").click();
          } else if (res && res.status == 401) {
            remove_session();
            getLoggedInUser();
            navigate("/login");
          } else {
            toast.error("Failed to update PDF.");
          }
          setLoading(false);
        });
      } else {
        const PDFData = {
          title: title ?? "",
          fileSize: fileSize ?? "",
          url: pdf,
          text: "",
          type: "pdf",
          workout: item?.workout,
        };
        updateWorkoutOverview(PDFData, item?._id).then((res) => {
          if (res && res.status == 200) {
            fetchData();
            toast.success("PDF updated successfully.");
            document.getElementById("categoryModalCloseButton").click();
          } else if (res && res.status == 401) {
            remove_session();
            getLoggedInUser();
            navigate("/login");
          } else {
            toast.error("Failed to update PDF.");
          }
          setLoading(false);
        });
      }
    }
  };

  const deleteHandler = (e, item) => {
    e.preventDefault();
    if (window.confirm("Are you sure you want to delete pdf overview permanently?") == true) {
      if (type === "week") {
        deleteWeekOverviewPermanently(item._id).then((res) => {
          if (res && res.status == 200) {
            fetchData();
            toast.success("PDF overview deleted successfully.");
          } else if (res && res.status == 401) {
            remove_session();
            getLoggedInUser();
            navigate("/login");
          } else {
            toast.error("Failed to delete pdf overview.");
          }
        });
      } else if (type === "day") {
        deleteWeekDayOverviewPermanently(item._id).then((res) => {
          if (res && res.status == 200) {
            fetchData();
            toast.success("PDF overview deleted successfully.");
          } else if (res && res.status == 401) {
            remove_session();
            getLoggedInUser();
            navigate("/login");
          } else {
            toast.error("Failed to delete pdf overview.");
          }
        });
      } else if (type === "lecture") {
        deleteLectureOverviewPermanently(item._id).then((res) => {
          if (res && res.status == 200) {
            fetchData();
            toast.success("PDF overview deleted successfully.");
          } else if (res && res.status == 401) {
            remove_session();
            getLoggedInUser();
            navigate("/login");
          } else {
            toast.error("Failed to delete pdf overview.");
          }
        });
      } else if (type === "programWeekLecture") {
        deleteProgramWeekLectureOverviewPermanently(item._id).then((res) => {
          if (res && res.status == 200) {
            fetchData();
            toast.success("PDF overview deleted successfully.");
          } else if (res && res.status == 401) {
            remove_session();
            getLoggedInUser();
            navigate("/login");
          } else {
            toast.error("Failed to delete pdf overview.");
          }
        });
      } else if (type === "day") {
        deleteWorkoutOverviewPermanently(item._id).then((res) => {
          if (res && res.status == 200) {
            fetchData();
            toast.success("PDF overview deleted successfully.");
          } else if (res && res.status == 401) {
            remove_session();
            getLoggedInUser();
            navigate("/login");
          } else {
            toast.error("Failed to delete pdf overview.");
          }
        });
      } else {
        deleteWorkoutOverviewPermanently(item._id).then((res) => {
          if (res && res.status == 200) {
            fetchData();
            toast.success("PDF overview deleted successfully.");
          } else if (res && res.status == 401) {
            remove_session();
            getLoggedInUser();
            navigate("/login");
          } else {
            toast.error("Failed to delete pdf overview.");
          }
        });
      }
    }
  };
  const setImageHandler = (pdf) => {
    setPdf(pdf);
  };

  return (
    <>
      <div className="col-6 bg-white" style={{ boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px", borderRadius: "10px" }}>
        <div
          className="py-4 text-black d-flex justify-content-between"
          style={{ fontSize: "18px", fontWeight: "500", cursor: "pointer" }}
          onClick={() => setIsopen(!isOpen)}
        >
          <span className="d-flex align-items-center" style={{ gap: "15px" }}>
            <DragHandler /> PDF {item?.title && `(${item?.title})`}
          </span>
          <img src={ArrowDown} />
        </div>
        {isOpen && (
          <div>
            <form noValidate onSubmit={handleUpdateOverviewPDF}>
              {pdfLoading ? (
                <div className="text-center py-5">
                  <div className="spinner-border text-black" role="status" aria-hidden="true"></div>
                </div>
              ) : (
                <>
                  <div className="form-group px-3">
                    <label>Title</label>
                    <input type="text" className="form-control" placeholder="Enter title" value={title} onChange={(e) => setTitle(e.target.value)} />
                    {/* {errors.title && !title && <div className="text-warning font-size-12 mt-2">{errors.title}</div>} */}
                  </div>
                  <div className="form-group py-4 text-center">
                    <label>{fileName}</label>
                    <br />
                    {(item?.url || pdf) && (
                      <>
                        <img src={PDFIcon} className="img-fluid img-thumbnail" width="100" />
                        <br />
                      </>
                    )}
                    <button
                      type="button"
                      onClick={() => setShowUpdatePDFModal(true)}
                      className="btn btn-primary mt-3"
                      data-toggle="modal"
                      data-target="#overViewPDF"
                    >
                      Select PDF
                    </button>
                    {!pdf && <div className="text-warning font-size-12 mt-2">PDF is required</div>}
                  </div>
                </>
              )}
              <div className="modal-footer border-0 px-0">
                {((hasPermission("edit-day-overview") && type === "day") ||
                  (hasPermission("edit-workout-overview") && type === "workout") ||
                  (hasPermission("edit-lecture-overview") && type === "lecture") ||
                  (hasPermission("edit-program-week-lecture-overview") && type === "programWeekLecture") ||
                  (hasPermission("edit-week-overview") && type === "week")) && (
                  <button type="submit" className="btn btn-primary btn-sm">
                    {loading && <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>} Update
                  </button>
                )}
                {((hasPermission("delete-day-overview") && type === "day") ||
                  (hasPermission("delete-workout-overview") && type === "workout") ||
                  (hasPermission("delete-lecture-overview") && type === "lecture") ||
                  (hasPermission("delete-program-week-lecture-overview") && type === "programWeekLecture") ||
                  (hasPermission("delete-week-overview") && type === "week")) && (
                  <button onClick={(e) => deleteHandler(e, item)} className="btn btn-danger btn-sm">
                    Delete
                  </button>
                )}
              </div>
            </form>
          </div>
        )}
      </div>
      {showUpdatePDFModal && <Media setFileName={setFileName} setFileSize={setFileSize} setImageHandler={setImageHandler} id={"overViewPDF"} />}
    </>
  );
};

export default PDFOverview;
